import { lazyLoad } from 'utils/loadable';

export const UsefulInfoFormPage = lazyLoad(
  () => import('./index'),
  module => module.UsefulInfoFormPage,
);
